export default {
  methods: {
    toggleDrawer ({target, value} = {}) {
      this.$store.commit('toggleDrawer', {
        target,
        value
      })
    },
  }
}
